import a from "../../constants/orientation.js";
const o = (t) => Object.values(a).includes(t);
export {
  o as default
};
